import { render, staticRenderFns } from "./InspectionDetail.vue?vue&type=template&id=18f8f29c&scoped=true"
import script from "./InspectionDetail.vue?vue&type=script&lang=js"
export * from "./InspectionDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionDetail.vue?vue&type=style&index=0&id=18f8f29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8f29c",
  null
  
)

export default component.exports